import { ReactElement } from 'react';

import { IconButton } from '@beeline/design-system-react/extracted-styles';
import { Icons } from '@beeline/design-tokens/js/iconfont';

import cn from 'classnames';

import styles from './styles.module.scss';

export const DefaultError = ({
  onRetry,
}: {
  onRetry?: () => void;
}): ReactElement => (
  <div className={cn(styles.Container, styles.Error)}>
    Ошибка загрузки компонента
    {onRetry && (
      <IconButton
        iconName={Icons.Refresh}
        onClick={onRetry}
        size='large'
        style={{ width: '48px', height: '48px' }}
      />
    )}
  </div>
);
